/* global swal, _, angular*/
import './style.less';

export default function($log) {
  'ngInject';

  const vm = this;

  vm.remove = i => vm.ngModel.splice(i, 1);

  vm.addCheckbox = () => {
    if (!vm.ngModel) vm.ngModel = [];
    const id = `${vm.ngModel.length + 1}_checkbox`;
    const checkbox = {
      disabled: false,
      id,
      name: undefined,
      required: true,
      answers: ['', '', '', '']
    };
    vm.ngModel.push(angular.copy(checkbox));
  };

  vm.updateCheckboxAnswer = (parentIndex, index, add) => {
    if (add === true) return vm.ngModel[parentIndex].answers.splice(index + 1, 0, '');
    vm.ngModel[parentIndex].answers.splice(index, 1);
  };
}



// WEBPACK FOOTER //
// ./src/app/components/forms/multiAnswer/input/controller.js